<template lang="html">
  <v-select
    ref="input"
    v-model="internalValue"
    v-bind="$attrs"
    :label="internalLabel"
    :rules="internalRules"
    data-lpignore="true"
    autocomplete="off"
    v-on="$listeners"
    @keyup.down="$refs.input.onClick()"
  >
    <template #item="{ item, index, on, attrs }">
      <v-list-item
        v-if="isObject(item)"
        :key="index"
        v-on="on"
      >
        <v-list-item-icon v-if="item.icon || $attrs.multiple !== undefined">
          <v-icon
            v-if="$attrs.multiple === undefined"
            v-text="item.icon"
          />
          <v-icon
            v-if="$attrs.multiple !== undefined && attrs.inputValue"
            color="primary"
          >
            check_box
          </v-icon>
          <v-icon v-if="$attrs.multiple !== undefined && !attrs.inputValue">
            check_box_outline_blank
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.text }}</v-list-item-title>
          <v-list-item-subtitle v-if="item.subtext">
            {{ item.subtext }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-else
        :key="index"
        v-on="on"
      >
        <v-list-item-content>
          <v-list-item-title>{{ item }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-select>
</template>

<script>
import helpers from '@/mixins/helpers'
import element from '@/mixins/element'

export default {
  mixins: [ helpers, element ],
  props: {
    value: [String, Array, Object, Boolean]
  },
  data () {
    return {
      lazyValue: this.value,
      requiredRule: v => this.selectRequiredRule(v)
    }
  },
  computed: {
    internalValue: {
      get () {
        return this.lazyValue
      },
      set (val) {
        this.lazyValue = val
        this.$emit('change', val)
      }
    }
  },
  watch: {
    value (val) {
      this.lazyValue = val
    },
    '$attrs.items' (items = []) {
      let { autoSelect, returnObject } = this.$attrs
      let item = items[0]
      let value = returnObject ? item : item.value
      if (items.length === 1 && autoSelect && this.internalValue !== value) {
        this.internalValue = value
      }
    }
  }
}
</script>

<style lang="css" scoped>

</style>
